import React from "react";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../atoms/Button";
import LoadingBar from "../atoms/LoadingBar";
export var PDFExportOverlay = function (_a) {
    var isVisible = _a.isVisible, _b = _a.progress, progress = _b === void 0 ? 0 : _b, _c = _a.currentStep, currentStep = _c === void 0 ? "Preparing PDF export..." : _c, onCancel = _a.onCancel, _d = _a.canCancel, canCancel = _d === void 0 ? true : _d;
    if (!isVisible)
        return null;
    return (React.createElement("div", { style: {
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
            animation: "pdfExportFadeIn 0.3s ease-out",
        }, onClick: function (e) {
            // Only close if clicking the backdrop, not the modal content
            if (e.target === e.currentTarget && canCancel) {
                onCancel();
            }
        } },
        React.createElement("div", { style: {
                backgroundColor: "white",
                borderRadius: "12px",
                padding: "32px",
                minWidth: "400px",
                maxWidth: "500px",
                boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)",
                animation: "pdfExportSlideIn 0.3s ease-out",
                position: "relative",
            }, onClick: function (e) { return e.stopPropagation(); } },
            canCancel && (React.createElement("button", { onClick: onCancel, style: {
                    position: "absolute",
                    top: "12px",
                    right: "12px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "#666",
                    fontSize: "18px",
                    padding: "8px",
                    borderRadius: "50%",
                    transition: "all 0.2s ease",
                }, onMouseEnter: function (e) {
                    e.currentTarget.style.backgroundColor = "#f5f5f5";
                    e.currentTarget.style.color = "#333";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.backgroundColor = "transparent";
                    e.currentTarget.style.color = "#666";
                }, title: "Cancel export" },
                React.createElement(FontAwesomeIcon, { icon: faTimes }))),
            React.createElement("div", { style: { textAlign: "center", marginBottom: "24px" } },
                React.createElement("h3", { style: {
                        margin: "0 0 8px 0",
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#333",
                    } }, "Exporting to PDF"),
                React.createElement("p", { style: {
                        margin: 0,
                        fontSize: "14px",
                        color: "#666",
                        lineHeight: "1.4",
                    } }, "Please wait while we generate your PDF document...")),
            React.createElement("div", { style: { marginBottom: "24px" } },
                React.createElement("div", { style: {
                        width: "100%",
                        height: "8px",
                        backgroundColor: "#f0f0f0",
                        borderRadius: "4px",
                        overflow: "hidden",
                        marginBottom: "12px",
                    } },
                    React.createElement("div", { style: {
                            width: "".concat(Math.max(0, Math.min(100, progress)), "%"),
                            height: "100%",
                            backgroundColor: "#007bff",
                            borderRadius: "4px",
                            transition: "width 0.3s ease",
                            animation: progress > 0 ? "none" : "pdfExportPulse 1.5s ease-in-out infinite",
                        } })),
                React.createElement("div", { style: {
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        fontSize: "13px",
                        color: "#666",
                    } },
                    React.createElement("span", null, currentStep),
                    progress > 0 && React.createElement("span", null,
                        Math.round(progress),
                        "%"))),
            progress === 0 && (React.createElement("div", { style: { marginBottom: "24px" } },
                React.createElement(LoadingBar, null))),
            canCancel && (React.createElement("div", { style: { textAlign: "center" } },
                React.createElement(Button, { onClick: onCancel, variant: "secondary" }, "Cancel Export")))),
        React.createElement("style", { dangerouslySetInnerHTML: {
                __html: "\n          @keyframes pdfExportFadeIn {\n            from { opacity: 0; }\n            to { opacity: 1; }\n          }\n          @keyframes pdfExportSlideIn {\n            from { opacity: 0; transform: scale(0.9) translateY(-20px); }\n            to { opacity: 1; transform: scale(1) translateY(0); }\n          }\n          @keyframes pdfExportPulse {\n            0%, 100% { opacity: 1; }\n            50% { opacity: 0.5; }\n          }\n        ",
            } })));
};
export default PDFExportOverlay;
